<template>
	<div id="airwayButtons" class="airway-mode-item">
		<button id="airwayVideoBtn" class="airway-bottom-button" disabled="disabled"
			v-on:click="generateAirwayVideoClick()">
			<span class="airway-video-span">GENERATE VIDEO</span>
			<img id="airwayVideoImg" class="airway-video-img" src="images/dark-blue-spinner.gif" />
		</button>

		<button id="airwayExitBtn" class="airway-bottom-button" v-on:click="exitAirwayModeClick()">
			EXIT
		</button>
	</div>
</template>

<script>

import {
	generateAirwayVideo,
	leaveAirwayMode
} from "./AirwayMode.js";

export default {
	name: "AirwayButtons",
	props: [],
	components: {},
	methods: {
		generateAirwayVideoClick: function () {
			generateAirwayVideo();
		},
		exitAirwayModeClick: function () {
			leaveAirwayMode();
		}
	}
};

</script>

<style scoped>
.airway-video-img {
	/* display: inline-block; */
	display: none;
	width: 32px;
	height: 32px;
	vertical-align: middle;
}

.airway-video-span {
	display: inline-block;
	vertical-align: middle;
}

#airwayButtons {
	position: absolute;
	left: calc(50% - 163px);
	bottom: 75px;
	height: 35px;
	z-index: 9;
	text-align: center;
	white-space: nowrap;
	display: none;
	width: 360px;
}

.airway-bottom-button {
	display: inline-block;
	min-width: 171px;
	height: 35px;
	cursor: pointer;
	font-size: small;
	background-color: #4687fc;
	text-align: center;
	color: #ffffff;
	border: 0;
}

#airwayExitBtn {
	margin-left: 10px;
}

#airwayVideoBtn {
	padding-left: 14px;
	cursor: not-allowed;
}
</style>